// TOP LEVEL IMPORTS
import React from 'react';
import styled from 'styled-components';
// COMPONENTS
import LinkText from 'components/text/LinkText';
import Body from 'components/text/Body';
import Title from 'components/text/Title';
import Modal from 'components/common/Modal';
import Alert from 'components/common/Alert';

const StyledTitle = styled(Title)`
  margin-bottom: 15px;
`;

const StyledLink = styled(LinkText)`
  display: inline;
`;

class WelcomeReminderModal extends React.Component {
  state = {
    visible: false,
  };

  handleOnClick = () => {
    this.setState({ visible: true });
  };

  closeModal = () => {
    this.setState({ visible: false });
  };

  render() {
    return (
      <div style={{ marginTop: 60, textAlign: 'center' }}>
        <Alert
          showIcon
          style={{ textAlign: 'left' }}
          type="info" 
          message={(
            <Title>Having trouble logging in?</Title>
          )}
          description={(
            <Body>
              <StyledLink
                style={{
                  marginTop: 20,
                  color: '#fff',
                }}
                onClick={this.handleOnClick}
              >
                Click here
              </StyledLink>
              for tips.
            </Body>
          )} 
          
        />
        
        <Modal cancelText="Close" onOk={this.closeModal} onCancel={this.closeModal} visible={this.state.visible}>
          <div>
            <StyledTitle>Welcome to Hey Ned, the client management software made just for photographers!</StyledTitle>
            <Body>
              You're going to love how easy Ned makes it to focus on what you do best, while he handles the rest! The
              BEST part is that as a Cole Classroom Pro member you get to enjoy it for FREE!
            </Body>
            <Body>
              But first, we need to get you set up with an account so that Ned can become your right hand man.
            </Body>
            <Body>To request access to Hey Ned, simply follow these 5 simple steps.</Body>
            <ol>
              <li>
                <Body>
                  
                  <StyledLink target="_blank" href="https://www.colesclassroom.com/members">
                  Click here 
                  </StyledLink>
                  and log into your Cole’s Classroom Pro Account.
                </Body>
              </li>
              <li>
                <Body>Click "Rewards", then "Hey Ned".</Body>
              </li>
              <li>
                <Body>
                  Click the "Request Access" button and wait for Ned to send you an email to set up your password (make
                  sure to check your spam!)
                </Body>
              </li>
              <li>
                <Body>
                  Set your password and log into Hey Ned! Your Cole's Classroom password WILL NOT work when logging into
                  Hey Ned, you'll need to use your new Hey Ned password.
                </Body>
              </li>
              <li>
                <Body>
                  Don't forget to watch our
                  <StyledLink target="_blank" href="https://hey-ned-help.helpscoutdocs.com/">
                  help videos
                  </StyledLink>
                  so you'll know just how Hey Ned can make your life easier!
                </Body>
              </li>
            </ol>
          </div>
        </Modal>
      </div>
    );
  }
}

export default WelcomeReminderModal;



// WEBPACK FOOTER //
// ./src/routes/auth-login/WelcomeReminderModal/index.js